'use client'

import { useEffect, useState, useTransition } from 'react'
import { useRouter } from 'next/navigation'

import { disableDraftMode } from '@/app/actions'
export function DisableDraftMode() {
  const [isEmbedded, setIsEmbedded] = useState(false)
  const router = useRouter()
  const [pending, startTransition] = useTransition()

  useEffect(() => {
    const embedded = typeof window !== 'undefined' && window.self !== window.top
    // In this case, this is fine. We need to do this after mount.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsEmbedded(embedded)
  }, [])

  if (isEmbedded) {
    return null
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        zIndex: 9999,
        background: '#1a1a1a',
        color: '#fff',
        borderRadius: 8,
        padding: '12px 16px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
        fontSize: 14,
        fontFamily: 'system-ui, sans-serif',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
      }}>
      <span style={{ opacity: 0.7 }}>
        Draft mode is enabled. You are seeing a draft content of the website.
      </span>
      <button
        type="button"
        disabled={pending}
        style={{
          padding: '6px 12px',
          background: '#e53e3e',
          color: '#fff',
          border: 'none',
          borderRadius: 4,
          cursor: pending ? 'wait' : 'pointer',
          fontSize: 13,
          fontWeight: 500,
          opacity: pending ? 0.6 : 1,
        }}
        onClick={() =>
          startTransition(async () => {
            await disableDraftMode()
            router.refresh()
          })
        }>
        {pending ? 'Disabling...' : 'Exit'}
      </button>
    </div>
  )
}
